/** UUID used to correlate QR payloads, scan URLs, and API ids (case-insensitive). */
export const UUID_PATTERN = /[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/i
